const en = {
   login:{ 
      title:'I am the title',
    
   },
   app:{
      title: " Electronic Technology Co., Ltd",
      one: "Home",
      two: "Enterprise dynamics",
      three: "Products",
      four: "Contact us"
   },
   index: {
      title: "Enjoy a Wonderful Life with Lotte",
      subtitle: "Join Us to Reach Every Wonderful Moment",
      description: "Discover Little Joys in Life, Ulejia Shares Good Times with You",
      button: "Get involved now",
      newProducts: "New Products Preview",
      viewDetails: "View Details",
      viewMore: "View More"
  },
  index_two: {
      title: "Home Goods Carnival",
      subtitle: "Ulejia's Special Sale on Small Household Items",
      description: "Carefully Selected 100+ Practical Home Goods, Starting at 20% Off for a Limited Time",
      button: "Grab it now",
  },
   case: {
      h1: "Contact Us",
      address: "Address:",
      addressDes: "Shangyuantang Area, Dongcheng Street, Sihui City, Guangdong Province, China",
      photo: "Mobile:",
      people1: "Ms. Zou:",
      people2: "Ms. Chen:",
      people3: "Mr. Chen:",
      p: "Follow us on WeChat"
   },
   news: {
      p1: "Sihui Letian Electronic Technology Co., Ltd. was established in 2004 and has been dedicated to the integrated services of creative small home appliances, including R&D, design, production, and sales for 19 years.",
      p2: "We maintain full control over the entire process from conceptual design to manufacturing, possessing mature capabilities to bring products to market. Through a rigorous quality control system and deep manufacturing expertise, we ensure the delivery of reliable, high-quality products to consumers.",
      p3: "With 'Scenario-based Innovation' as our core strategy, our product designs integrate technology and youthful aesthetics, covering smart home devices, personal care, and household appliances. By continuously exploring the needs of Generation Z in various life scenarios, we are committed to providing innovative solutions with aesthetic appeal.",
      p4: "Innovation Gene | Youthful Advocacy | Commitment to Quality",
      t0:"Company Profile",
      t1: "Corporate Culture",
      t2: "Development History",
      t3: "Cultural Advantages",
      t4: "Work Environment",
      t5: "Corporate Honors",
      t6: "Join Us",
      button: "Join Now"
  },
     product: {
        h1: "Product Center",
        price: "Price: ",
        sale: "Sales: ",
        ku: "Stock: 99",
        h3: "Contact for Purchase",
        h4: "Leave a Message Online",
        photo: "Your Phone Number",
        name: "Your Name",
        button: "Submit Now",
        underConstruction: "Product content is under construction..."
     },
   productDetail: {
      price: "Price",
      number: "Number",
      promotion: "Coupon",
      promotionDes: "Save 30 on orders over 299",
      color: "Select Color",
      standard: "Product Specifications",
      addToCart: "Add to Cart",
      button: "Buy Now"
  },
     footer: {
        name0: "Youle Servant",
        name1: "Manufacturer:",
        name2: "Sihui Letian Electronics Technology Co., Ltd.",
        name3: "Factory Address:",
        name4: "Shangyuan Tang Area, Dongcheng Street, Sihui City, Guangdong Province",
        name5: "Scan to follow us",
        name6: "Legal Statement",
        name7: "Record No.: 粤ICP备20005346号",
        name8: "©2023 Sihui Letian Electronics Technology Co., Ltd. All rights reserved",
        followOfficialAccount: "Follow Official Account",
        headquarterAddress: "Headquarter Address: No. 2, Xingsheng Road, Huanggang Community, Dongcheng Street, Sihui City, Zhaoqing, Guangdong Province",
        branchetAddress: "Branch Address: Room 203, Building A, Xijuzhongxin, Jianshe North Road, Baiyun District, Guangzhou"
     },
     nav: {
        home: "Home",
        products: "Products",
        about: "About Us",
        news: "News",
        service: "Service",
        join: "Join Us",
        find: "Find Us",
        language: "中文/EN",
      
        // Products submenu
        fanSeries: "Fan Series",
        lampSeries: "Lamp Series",
        nightLight: "Night Light",
        mosquitoLamp: "Mosquito Lamp",
        humidifier: "Humidifier",
        heater: "Heater",
        handWarmer: "Hand Warmer",
        ipSeries: "IP Series",
      
        // About Us submenu
        brandIntro: "Brand Introduction",
        history: "History",
        video: "Brand Video",
        honors: "Honors",
      
        // News submenu
        exhibition: "Exhibitions",
        companyNews: "Company News",
      
        // Service submenu
        contactUs: "Contact Us",
      
        // Join Us submenu
        socialRecruitment: "Social Recruitment",
        campusRecruitment: "Campus Recruitment",
        internalReferral: "Internal Referral"
     },
     recruitment: {
        title: "Career Opportunities",
        arrow: ">",
        location: "Location",
        salary: "Salary Range",
        applyNow: "Apply Now",
        apply: "Application",
        name: "Name",
        phone: "Phone",
        email: "Email",
        resume: "Resume Upload",
        cancel: "Cancel",
        submit: "Submit Application",
        officeEnv: "Office Environment",
        lab: "Modern R&D Lab",
        cafe: "Employee Cafe",
        workshop: "Smart Workshop",
        testLab: "Material Testing Lab",
        meetingRoom: "Multifunctional Meeting Room",
        gym: "Employee Gym",
        showroom: "Product Showroom",
        garden: "Campus Greenery",
        jobOpenings: "Job Openings",
        frontendDev: "Frontend Developer",
        uiDesigner: "UI Designer",
        shenzhen: "Shenzhen",
        frontendDesc: "Responsible for frontend project development, participating in product requirements discussion and technical solution design.",
        uiDesc: "Responsible for product interface design, participating in the formulation and maintenance of design specifications.",
        applySuccess: "'s application has been submitted successfully!"
     },
     album: {
        yearTitle: "2025·New Chapter",
        brandBook: "Brand Brochure",
        slogan: "Elegant Your Life Aesthetics", 
        pdfName: "2025-Letian Product Catalog.pdf"
     },
     service: {
        title: "Contact Us",
        hq: "Zhaoqing Headquarters",
        branch: "Guangzhou Branch",
        phone: "Service Hotline",
        email: "Service Email",
        address: "Company Address"
     }
}
export default en;